import { render } from "./matching-badge-modal.vue?vue&type=template&id=23cdba8c&ts=true"
import script from "./matching-badge-modal.vue?vue&type=script&lang=ts"
export * from "./matching-badge-modal.vue?vue&type=script&lang=ts"

import "./matching-badge-modal.vue?vue&type=style&index=0&id=23cdba8c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__